<div class="container-fluid">
  <!-- Page Heading -->
  <div class="page-heading mb-4">
    <h1 class="h3 mb-2 text-gray-800">
      <i class="fas fa-photo-video"></i> Các Loại Phương Tiện
    </h1>
    <p class="mb-4">Mô-đun này cung cấp tổng quan và quản lý các loại phương tiện khác nhau trong thư viện, bao gồm thống kê và danh sách chi tiết.</p>
  </div>

  <!-- Nav tabs -->
  <ul class="nav nav-tabs">
    <li class="nav-item">
      <a class="nav-link active" data-toggle="tab" href="#dashboard">
        <i class="fas fa-tachometer-alt"></i> Bảng Điều Khiển
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#list">
        <i class="fas fa-list"></i> Danh Sách
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#UserManual">
        <i class="fas fa-book mr-2"></i> Hướng Dẫn Sử Dụng
      </a>
    </li>
  </ul>

  <!-- Tab panes -->
  <div class="tab-content">
    <div id="dashboard" class="container tab-pane active bg-white p-3 mt-3 rounded">
      <div class="container bg-white p-3 mt-3 rounded">
        <!-- Content for the Dashboard tab -->
        <div class="row">
          <div class="col-md-6">
            <h4>Số Lượng Mục Phương Tiện Theo Loại</h4>
            <ngx-charts-bar-vertical
              [view]="view"
              [scheme]="'cool'"
              [results]="mediaItemsByTypeData"
              [gradient]="gradient"
              [xAxis]="true"
              [yAxis]="true"
              [legend]="showLegend"
              [showXAxisLabel]="true"
              [showYAxisLabel]="true"
              [xAxisLabel]="'Loại Phương Tiện'"
              [yAxisLabel]="'Mục'">
            </ngx-charts-bar-vertical>
          </div>
          <div class="col-md-6">
            <h4>Phân Phối Phương Tiện Theo Thể Loại</h4>
            <ngx-charts-pie-chart
              [view]="view"
              [scheme]="'cool'"
              [results]="mediaByGenreData"
              [legend]="showLegend"
              [labels]="showLabels"
              [doughnut]="isDoughnut"
              [gradient]="gradient">
            </ngx-charts-pie-chart>
          </div>
          <div class="col-md-6">
            <h4>Xu Hướng Thu Nhập Phương Tiện Theo Thời Gian</h4>
            <ngx-charts-line-chart
              [view]="view"
              [scheme]="'cool'"
              [results]="mediaAcquisitionTrendsData"
              [gradient]="gradient"
              [xAxis]="true"
              [yAxis]="true"
              [legend]="showLegend"
              [showXAxisLabel]="true"
              [showYAxisLabel]="true"
              [xAxisLabel]="'Năm'"
              [yAxisLabel]="'Mục'">
            </ngx-charts-line-chart>
          </div>
          <div class="col-md-6">
            <h4>Các Loại Phương Tiện Hàng Đầu Theo Số Lần Mượn</h4>
            <ngx-charts-bar-horizontal
              [view]="view"
              [scheme]="'cool'"
              [results]="topMediaTypesByBorrowCountData"
              [gradient]="gradient"
              [xAxis]="true"
              [yAxis]="true"
              [legend]="showLegend"
              [showXAxisLabel]="true"
              [showYAxisLabel]="true"
              [xAxisLabel]="'Số Lần Mượn'"
              [yAxisLabel]="'Loại Phương Tiện'">
            </ngx-charts-bar-horizontal>
          </div>
        </div>
        <!-- Thêm nội dung bảng điều khiển tại đây -->
      </div>
    </div>
    <div id="list" class="container tab-pane fade bg-white p-3 mt-3 rounded">

      <div class="card mb-4">
        <div class="card-body">
          <button type="button" class="btn btn-outline-primary" (click)="openAddDialog()">
            <i class="fas fa-plus"></i> Thêm Phương Tiện
          </button>
          <button
            href="#"
            role="button"
            class="btn btn-outline-warning btn-icon-split"
            (click)="reloadPage()"
          >
            <span class="icon text-warning">
              <i class="fas fa-redo"></i>
            </span>
            <span class="text">Tải lại</span>
          </button>
        </div>
      </div>  
      



      <div *ngIf="loading; else loaded">
        <div class="d-flex justify-content-center">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Đang tải...</span>
          </div>
        </div>
      </div>

      <ng-template #loaded>
        
      <div class="table-responsive">
        <div class="card mb-4">
          <div class="card-body">
            <ngx-datatable 
            class="bootstrap"
            [rows]="itemTypes"
            [columnMode]="'force'"
            [headerHeight]="50"
            [footerHeight]="50"
            [rowHeight]="'auto'"
            [limit]="10"
            [loadingIndicator]="loading"
            [reorderable]="reorderable"
            (select)="onSelect($event)"
            (activate)="onActivate($event)"
          >
          <ngx-datatable-column name="Tên" [prop]="'name'">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span class="blue-text">
                {{ row.name }}
              </span>
            </ng-template>
          </ngx-datatable-column>
    
            <!-- Cột phí thuê (USD) -->
            <ngx-datatable-column name="Phí thuê ($)">
              <ng-template ngx-datatable-cell-template let-row="row">
                {{ convertToDollar(row.rentalCharge) | number:'1.2-2' }} $
              </ng-template>
            </ngx-datatable-column>
          
            <!-- Cột phí thuê theo ngày (USD) -->
            <ngx-datatable-column name="Phí thuê theo ngày ($)">
              <ng-template ngx-datatable-cell-template let-row="row">
                {{ convertToDollar(row.dailyRentalCharge) | number:'1.2-2' }} $/ngày
              </ng-template>
            </ngx-datatable-column>
          
            <!-- Cột phí thuê theo giờ (USD) -->
            <ngx-datatable-column name="Phí thuê theo giờ ($)">
              <ng-template ngx-datatable-cell-template let-row="row">
                {{ convertToDollar(row.hourlyRentalCharge) | number:'1.2-2' }} $/giờ
              </ng-template>
            </ngx-datatable-column>
          
            <!-- Cột chi phí thay thế mặc định (USD) -->
            <ngx-datatable-column name="Chi phí thay thế ($)">
              <ng-template ngx-datatable-cell-template let-row="row">
                {{ convertToDollar(row.defaultReplacementCost) | number:'1.2-2' }} $
              </ng-template>
            </ngx-datatable-column>
          
            <!-- Cột phí xử lý (USD) -->
            <ngx-datatable-column name="Phí xử lý ($)">
              <ng-template ngx-datatable-cell-template let-row="row">
                {{ convertToDollar(row.processingFee) | number:'1.2-2' }} $
              </ng-template>
            </ngx-datatable-column>
    
             <!-- Cột thao tác -->
            <ngx-datatable-column name="Thao tác">
              <ng-template ngx-datatable-cell-template let-row="row">
              <!--   <button class="btn btn-sm btn-outline-primary mr-2" (click)="openViewDialog(row)">
                  View
                </button> -->
              <!--  <button class="btn btn-sm btn-danger" (click)="deleteRow(row)">
                  Delete
                </button> -->
                <button class="btn btn-sm btn-outline-primary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  Thao tác
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <a class="dropdown-item"  (click)="openViewDialog(row)">
                    <i class="fas fa-eye mr-2"></i> Xem
                  </a>
                  <a class="dropdown-item"  (click)="openEditDialog(row)">
                    <i class="fas fa-edit mr-2"></i> Sửa
                  </a>
                  <!-- <a class="dropdown-item text-danger"  (click)="deleteRow(row)">
                    <i class="fas fa-trash-alt mr-2"></i> Delete
                  </a> -->
                </div>
              </ng-template>
            </ngx-datatable-column>
            
          </ngx-datatable>
            </div>
        </div>    

       
      
      </div>
    </ng-template>
    </div>


    <div id="UserManual" class="tab-pane custom-tab-pane">
      <!-- Nội dung hướng dẫn sử dụng -->
      <div>
         <!-- <markdown [src]="markdownContent" [data]="markdownContent"></markdown>  -->
          <div  [innerHTML]="markdownContent"></div>
      </div>
    </div>
    
  </div>
</div>

<!-- Modal -->
<!-- Add/edit form -->